import {
	getPopupAssetResolved,
	getPopupDetails,
	getPopupInspections,
	getPopupInspectionsClear,
	getPopupInspectionsRejected,
	getPopupInspectionsResolved,
	getPopupRisk,
	getPopupRiskClear,
	getPopupRiskRejected,
	getPopupRiskResolved,
} from '@Actions/popup.actions';
import { AssetRiskAndCondition } from '@innovyze/lib-am-common/types/asset.types';
import { InspectionScoredAttributes } from '@innovyze/lib-am-common/types/inspectionAttributes.types';
import { createReducer } from '@reduxjs/toolkit';
import { PopupAsset } from '@Types/popup.types';
import { AnyAction } from 'redux';

export interface PopStoreState {
	asset: PopupAsset | null;
	inspections: {
		data: InspectionScoredAttributes[] | null;
		loading: boolean;
	};
	selected: PopupAsset | null;
	risk: { data: AssetRiskAndCondition | null; loading: boolean };
}

export const initState: PopStoreState = {
	asset: null,
	inspections: { data: null, loading: false },
	selected: null,
	risk: { data: null, loading: false },
};

interface PopupReducer {
	[x: string]: (
		state: PopStoreState,
		action: AnyAction,
	) => PopStoreState | undefined;
}

const reducer: PopupReducer = {
	[getPopupDetails.toString()]: (state, action) => ({
		...state,
		selected: action.payload,
	}),
	[getPopupAssetResolved.toString()]: (state, action) => ({
		...state,
		asset: action.payload,
	}),
	[getPopupInspections.toString()]: state => ({
		...state,
		inspections: { ...state.inspections, loading: true },
	}),
	[getPopupInspectionsClear.toString()]: state => ({
		...state,
		inspections: { ...state.inspections, data: null },
	}),
	[getPopupInspectionsResolved.toString()]: (state, action) => ({
		...state,
		inspections: { data: action.payload, loading: false },
	}),
	[getPopupInspectionsRejected.toString()]: state => ({
		...state,
		inspections: { ...state.inspections, loading: false },
	}),
	[getPopupRisk.toString()]: state => ({
		...state,
		risk: { ...state.risk, loading: true },
	}),
	[getPopupRiskClear.toString()]: state => ({
		...state,
		risk: { ...state.risk, data: null },
	}),
	[getPopupRiskResolved.toString()]: (state, action) => ({
		...state,
		risk: { data: action.payload, loading: false },
	}),
	[getPopupRiskRejected.toString()]: state => ({
		...state,
		risk: { ...state.risk, loading: false },
	}),
};

export default createReducer(initState, reducer);
